import { module } from 'stereomodularjs';
import { SplitText } from 'gsap/SplitText';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.splitLine = new SplitText(this.el, { type: 'lines' });
        this.splitLine.lines.forEach((line) => {
            line.classList.add('u-text-clip');
            line.innerHTML = `<span class="u-text-clip__inner">${line.innerHTML}</span>`;
        });
    }


    destroy() {
        this.splitLine.revert();
    }
}